import React from 'react';
import DistancePicker from '../shared/DistancePicker';
import { getDistanceLimits } from '../onboardingQuestions';

interface StepProps {
  answer: any;
  onAnswer: (value: any) => void;
  answers: Record<string, any>;
}

const TrainingDistanceStep: React.FC<StepProps> = ({ answer, onAnswer, answers }) => {
  const limits = getDistanceLimits('training_distance', answers.programme_type ?? null);

  return (
    <DistancePicker
      value={answer && typeof answer === 'object' ? answer : null}
      onChange={onAnswer}
      minKm={limits.minKm}
      maxKm={limits.maxKm}
      minMiles={limits.minMiles}
      maxMiles={limits.maxMiles}
    />
  );
};

export default TrainingDistanceStep;
